import './aos';
import './main.scss';

import { HHDS } from '@hhh/teravalis-design-system/lib/hhds';
// import { HHDSModal, HHDSModalTagName } from '../../../../../teravalis-design-system/lib/components/Modal/Modal';
import HHDSButtonUtils, { HHDSButtonHasRegisterPropertyClass } from '@hhh/teravalis-design-system/lib/components/Button/ButtonUtils';
import { ModalController } from '@hhh/teravalis-design-system/lib/components/Modals/ModalController';

HHDS.register(false, 'plugin');

window.addEventListener('DOMContentLoaded', () => {
	document.body.classList.add('loaded');

	handleSubscribeButton();

	handleTourButton();

	handleRequestInfoButton();

	handleFloorplanButton();
});

function handleSubscribeButton() {
	// Define the target element to observe (in this case, the whole document)

	const container = document.querySelector('[ref="hubspot-form"]');

	if (!container) return; // //////////////////////////////////////////////////

	const targetNode = container;

	// Create a MutationObserver instance
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type !== 'childList') return; // ///////////////////////////

			// Check if the desired element is added
			const addedForm = Array.from(mutation.addedNodes).find((node) => node.nodeType === 1 && (node as HTMLElement).tagName === 'FORM') as
				| HTMLFormElement
				| undefined;

			if (!addedForm) return; // //////////////////////////////////////////////

			const buttonSubmitSelector = 'input[type="submit"]';

			const buttonSubmit = addedForm.querySelector(buttonSubmitSelector) as HTMLElement;

			if (!buttonSubmit) return; // ///////////////////////////////////////////

			const supportsRegisterProperty = window.CSS && typeof (window.CSS as any).registerProperty === 'function';

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Required for the animation to run
			// See teravalis-design-system/lib/components/Button/Button.ts

			HHDSButtonUtils.addCustomProperty();

			buttonSubmit.parentElement?.classList.toggle(HHDSButtonHasRegisterPropertyClass, supportsRegisterProperty);
		}
	});

	// Configuration options for the observer
	const config = { childList: true, subtree: true };

	// Start observing
	observer.observe(targetNode, config);
}

function handleTourButton() {
	const btnTour = document.querySelector('#btn-tour') as HTMLButtonElement;
	if (!btnTour) return; // //////////////////////////////////////////////////

	btnTour.addEventListener('click', (event) => {
		event.preventDefault();
		const tourUrl = btnTour.getAttribute('url') as string;
		if (!tourUrl) return; // //////////////////////////////////////////////
		openTour(tourUrl);
	});
}

function openTour(url: string) {
	const modal = ModalController.getInstance();
	modal.setURL(url);
	modal.open();
}

function handleFloorplanButton() {
	const btnFloorplan = document.querySelector('#btn-floorplan') as HTMLButtonElement | HTMLAnchorElement;
	if (!btnFloorplan) return; // //////////////////////////////////////////////////

	btnFloorplan.addEventListener('click', (event) => {
		event.preventDefault();

		const interactive = btnFloorplan.getAttribute('interactive') as string;
		if (interactive) {
			openFloorplan(interactive);
		} else {
			const url = btnFloorplan.getAttribute('file') as string;
			if (!url) return;
			downloadFloorplan(url);
		}
	});
}

function openFloorplan(url: string) {
	const modal = ModalController.getInstance();
	modal.setURL(url);
	modal.open();
}

function downloadFloorplan(url: string) {
	console.log('DOWNLOADIN FLOORPLAN');
	const link = document.createElement('a');
	link.href = url;
	link.download = url.split('/').pop();
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

function handleRequestInfoButton() {
	// customElements.whenDefined(HHDSModalTagName).then(() => {
	// 	const btn = document.getElementById('btn-requestinfo')!; // using your ID
	// 	const modal = document.getElementById('hubspot-modal') as HHDSModal;

	// 	btn?.addEventListener('click', () => {
	// 		modal.show();
	// 	});
	// });

	const btnRequestInfo = document.querySelector('#btn-requestinfo') as HTMLButtonElement;
	if (!btnRequestInfo) return;

	btnRequestInfo.addEventListener('click', (event) => {
		event.preventDefault();
		const builder = btnRequestInfo.getAttribute('data-builder-name') as string;
		const plan = btnRequestInfo.getAttribute('data-plan-name') as string;
		const lot = btnRequestInfo.getAttribute('data-lot-number') as string;
		openRequestInfoform(builder, plan, lot);
	});
}

function openRequestInfoform(builder: string = null, plan: string = null, lot: string = null) {
	const modal = ModalController.getInstance();
	modal.setContent(`
		<div class="hubspot-form">
			<div class="hubspot-form__wrapper">
				<h2 slot="heading" class="heading heading--02" style="margin: 0;">Request Info - ${builder}</h2>
				<span class="hubspot-form__content"></span>
			</div>
		</div>
	`);

	modal.onOpen(async () => {
		(window as any).hbspt.forms.create({
			region: 'na1',
			portalId: '47681518',
			formId: 'b93ff1c4-775e-4c8b-8ac9-20bee7371fb2',
			target: '.hubspot-form__content',
			onFormReady: (form: any) => {
				// Valid Builder IDs

				// - Brightland
				// - Century Communities
				// - KB Home
				// - Courtland
				// - Lennar
				// - Meritage Homes
				// - New Home Co.

				const textarea = modal.getContainer().querySelector(`textarea`) as any;
				if (textarea) {
					let text = `Builder: ${builder} \n`;
					if (plan) text += `Plan: ${plan} \n`;
					if (lot) text += `Lot: ${lot} \n`;
					textarea.value = text;
					console.log('Setting textarea value:', text);
				}

				const selectBuilder = modal.getContainer()?.querySelector('[name="select_builder"]') as HTMLSelectElement;
				if (selectBuilder) {
					selectBuilder.value = builder || '';
					console.log('Setting select_builder value:', selectBuilder.value);
				}

				console.log(modal.getContainer().querySelector('[name="select_builder"]'));
			},
			// onFormSubmit: function (form: any) {
			// 	DEBUG_VERBOSE && console.log('Form is being submitted...');
			// 	DEBUG_VERBOSE && console.log(form);
			// },
			// onFormSubmitted: function (form: any) {
			// 	DEBUG_VERBOSE && console.log('Form was submitted successfully!');
			// 	DEBUG_VERBOSE && console.log(form);
			// },
		});

		modal.addClassToCloseButton('hhds-simple-modal--close--grey-on-mobile');
	});

	modal.open();
}

document.addEventListener('request-info', (event: any) => {
	// The BuildersSection component dispatches request-info from
	// the map popup if the builder is flagged as Coming Soon.
	openRequestInfoform(event.detail.builder);
});
